import {Component, OnInit} from '@angular/core';
import {MatError, MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {NgIf} from '@angular/common';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {finalize, tap} from 'rxjs';
import {RecaptchaService} from '../../services/recaptcha.service';
import {environment} from '../../../environments/environment';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatButton} from '@angular/material/button';
import {MatProgressSpinner} from '@angular/material/progress-spinner';

@Component({
  selector: 'app-feedback',
  imports: [
    MatError,
    MatFormField,
    MatInput,
    MatLabel,
    NgIf,
    ReactiveFormsModule,
    TranslatePipe,
    MatFormField,
    MatError,
    MatCheckbox,
    MatButton,
    MatProgressSpinner,
  ],
  templateUrl: './feedback.component.html',
  styleUrl: './feedback.component.scss'
})
export class FeedbackComponent implements OnInit {
  public formGroup: FormGroup = null;
  public loading = false;
  public submitted = false;

  constructor(
    private fb: FormBuilder, private http: HttpClient, private recaptcha: RecaptchaService) {
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      name: ['', Validators.required],
      companyName: [''],
      message: ['', Validators.required],
      publish: [false, Validators.requiredTrue],
    })
  }

  async onSubmit() {
    this.formGroup.markAllAsTouched();
    const form = this.formGroup.getRawValue();

    if (this.formGroup.invalid || this.loading) {
      return;
    }
    this.loading = true;

    const recaptchaToken = await this.recaptcha.execute('feedback');

    this.http.post(`${environment.apiUrl}/feedback`, form, {
      headers: {'X-Recaptcha-Token': recaptchaToken},
    }).pipe(
      tap(() => {
        this.submitted = true;
      }),
      finalize(() => this.loading = false)
    ).subscribe()
  }
}
